import { useCheckoutStore } from '@seaters/data-access';
import { useState } from 'react';

export function useFormSteps(
  stepsLength: number,
  handleAcceptAsGuest: () => void
): {
  currentStep: number;
  prevStep: () => void;
  nextStep: () => void;
  isLastStep: boolean;
} {
  const [currentStep, setCurrentStep] = useState<number>(0);

  const { setCheckoutShown } = useCheckoutStore();

  const isLastStep = currentStep === stepsLength - 1;

  const prevStep = () => {
    if (currentStep === 0) {
      setCheckoutShown(false);
    } else {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleAcceptTickets = () => {
    setCheckoutShown(false);
    handleAcceptAsGuest();
  };

  const nextStep = () => {
    if (isLastStep) {
      // accept tickets
      handleAcceptTickets();
    } else {
      setCurrentStep(currentStep + 1);
    }
  };

  return {
    currentStep,
    prevStep,
    nextStep,
    isLastStep,
  };
}
